import React, { useContext } from "react"
import {Button} from "react-bootstrap"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faPlus} from "@fortawesome/free-solid-svg-icons"
import {RootContext} from "../contexts/RootContext"
import {ResourceContext} from "../contexts/ResourceContext"

const ResourceCreateButton = ({children, onClick, endpoint, disabled}) => {
  const { canCreate } = useContext(RootContext)
  const { resources } = useContext(ResourceContext)

  const handleClick = (ev) => {
    onClick(ev, resources)
  }

  return (
    <Button
      variant="dark"
      onClick={handleClick}
      disabled={disabled || !canCreate(endpoint)}>
      <FontAwesomeIcon icon={faPlus} />&nbsp;
      <span className="hide-for-sm">
      {children}
      </span>
    </Button>
  )
}

export default ResourceCreateButton
